module.exports = __WEBPACK_EXTERNAL_MODULE_14__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 14
// module chunks = 0